import React, {useEffect, useState} from 'react';
import {Stack, TextField, InputAdornment, IconButton} from '@mui/material';
import logInModel from './models/logInModel'
import {Field, useFormikContext} from "formik";
import { styled } from '@mui/material/styles';
import { Email, Lock, Visibility, VisibilityOff } from '@mui/icons-material';

const {formField: {logInEmail, logInPass}} = logInModel;

const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
    transition: 'all 0.3s ease',
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderWidth: '2px',
    },
  },
  '& .MuiInputLabel-root': {
    transition: 'all 0.3s ease',
  },
  '& .MuiInputAdornment-root': {
    color: theme.palette.text.secondary,
  }
}));

interface OwnProps {
  apiError?: string
}

const LoginFields = (props: OwnProps) => {
  const {errors, touched, setErrors} = useFormikContext<any>();
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    setErrors({[logInPass.name]: props.apiError})
  }, [props.apiError, setErrors])

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
  <Stack width="100%" spacing={3} pt={2}>
    <Field
      as={StyledTextField}
      variant="outlined"
      fullWidth
      data-cy={logInEmail.name}
      name={logInEmail.name}
      label={logInEmail.label}
      required={logInEmail.required}
      inputProps={{required: false}}
      type={logInEmail.inputType}
      error={Boolean(errors[logInEmail.name])}
      helperText={errors[logInEmail.name] ? errors[logInEmail.name] : ''}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Email fontSize="small" />
          </InputAdornment>
        ),
      }}
    />

    <Field
      as={StyledTextField}
      variant="outlined"
      fullWidth
      data-cy={logInPass.name}
      name={logInPass.name}
      label={logInPass.label}
      required={logInPass.required}
      inputProps={{required: false}}
      type={showPassword ? 'text' : 'password'}
      error={touched[logInPass.name] && Boolean(errors[logInPass.name])}
      helperText={(touched[logInPass.name] && errors[logInPass.name]) ? errors[logInPass.name] : ''}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Lock fontSize="small" />
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              edge="end"
              size="small"
            >
              {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
            </IconButton>
          </InputAdornment>
        )
      }}
    />
  </Stack>
  )
}

export default LoginFields
